// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-form .sample-list .common-btn{background:rgba(255,102,0,.05);width:142px}.create-form .sample-list .el-form-item{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
